import { AST } from '@handlebars/parser';
import { NodeType } from '../../node/types';

export const isSubExpression = (expression: AST.Expression): expression is AST.SubExpression =>
  expression.type === NodeType.SubExpression;
